export default __webpack_public_path__ + "chevron-left-white.svg";